export default "__VITE_ASSET__558536e5__"